module.exports = __webpack_public_path__ + "images/file_icons_v2/xml-b032e08d8755f3b77e06685c273a1d19.svg";